import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

// Syncfusion modules
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { ColumnChooserService, FilterService, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';

// Component
import { EligibilityDetailsComponent } from './eligibility-details.component';

// Services
import { CommonApiService } from '../../service/commonapiservice';

const routes: Routes = [
  {
    path: '',
    component: EligibilityDetailsComponent
  }
];

@NgModule({
  declarations: [
    EligibilityDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MaskedTextBoxModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    ColumnChooserService,
    PageService,
    SortService,
    FilterService,
    ResizeService,
    CommonApiService
  ],
  exports: [
    EligibilityDetailsComponent
  ]
})
export class EligibilityDetailsModule { }
